import { render, staticRenderFns } from "./Catalogs.vue?vue&type=template&id=9b565712"
import script from "./Catalogs.vue?vue&type=script&lang=js"
export * from "./Catalogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b565712')) {
      api.createRecord('9b565712', component.options)
    } else {
      api.reload('9b565712', component.options)
    }
    module.hot.accept("./Catalogs.vue?vue&type=template&id=9b565712", function () {
      api.rerender('9b565712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/catalog/Catalogs.vue"
export default component.exports